export enum configType {
    LOADER = 'LOADER',
    ROWID = 'ROWID'
}